var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-text-field", {
        ref: "fileTextField",
        attrs: {
          "prepend-icon": "attach_file",
          "single-line": "",
          label: _vm._f("cap")(
            _vm.src
              ? _vm.filename
              : _vm.$t("choose") + " / " + _vm.$t("edit") + "..."
          ),
          disabled: _vm.disabled,
          readonly: "",
          "append-icon": _vm.filename ? "delete" : ""
        },
        on: { "click:prepend": _vm.onFocus, "click:append": _vm.reset },
        nativeOn: {
          click: function($event) {
            return _vm.onFocus.apply(null, arguments)
          }
        },
        model: {
          value: _vm.filename,
          callback: function($$v) {
            _vm.filename = $$v
          },
          expression: "filename"
        }
      }),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        attrs: {
          type: "file",
          accept: _vm.accept,
          multiple: "false",
          disabled: _vm.disabled
        },
        on: { change: _vm.onFileChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bb73faf", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bb73faf","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzFileSelector.vue
// module id = null
// module chunks = 